import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import useAutoSelectValue from '../util/use-auto-select-value';

const options = [
  { id: '1', label: 'Excel', value: 1 },
  { id: '2', label: 'PDF', value: 2 },
];

export function FileFormatFilter({
  autoSelectIfEmpty = false,
  useContextFn,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    format: number;
    setFormat: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { format: value, setFormat: onChange } = useContextFn();
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess: true,
  });

  const handleChange = useTransformSelectValue(onChange);
  const helperText = errorMessages['format'];
  return (
    <Select
      fullWidth
      size="small"
      value={value}
      label="Format"
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
